const {
  getSolJourneyConfigForJourney,
} = require("./getSolJourneyConfigForJourney");

const getCitroenRegistrationFee = (journey, businessModel, configuration) => {
  const registration = getSolJourneyConfigForJourney(
    journey,
    businessModel,
    configuration
  )?.vehicleRegistration?.citroenRegistration;

  if (
    !registration?.enabled ||
    !registration.includeInPrice ||
    !Number.isFinite(registration.price) ||
    registration.price <= 0
  ) {
    return 0;
  }

  return registration.price;
};

module.exports = { getCitroenRegistrationFee };
